import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import tw from 'tailwind-styled-components'
import { FileFragment } from '@foros-fe/graphql'
import { Button } from './Button'
import { removeDuplicateObjects } from '../utils'

type Props = {
  files: Omit<FileFragment, 'typename'>[]
}

const Container = tw.div`flex flex-1 flex-col mb-10`
const Title = tw.p`font-medium text-xl mb-3`
const Line = tw.div`flex flex-wrap gap-2`

export const AuctionFiles: FC<Props> = ({ files }) => {
  const { t } = useTranslation('auctions')

  return (
    <Container>
      <Title>{t('auctionFiles')}</Title>
      <Line>
        {removeDuplicateObjects(files).map((f, i) => (
          <a key={`fk-${i}`} href={f.url} target='_blank' rel='noreferrer'>
            <Button title={f.filename} value='download-auction-file' />
          </a>
        ))}
      </Line>
    </Container>
  )
}
